import { render, staticRenderFns } from "./MultipleFileUpload.vue?vue&type=template&id=0a6569d2&scoped=true"
import script from "./MultipleFileUpload.vue?vue&type=script&lang=js"
export * from "./MultipleFileUpload.vue?vue&type=script&lang=js"
import style0 from "./MultipleFileUpload.vue?vue&type=style&index=0&id=0a6569d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6569d2",
  null
  
)

export default component.exports